
/*Package importing*/
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

/*Components*/
import SelectBox from '../../components/formComponents/selectBox';
import ViewSampleModal from '../../components/modals/viewSampleModal';
import APILoader from '../../components/other/api-loader';

/*Services*/
import devconfig from '../../config/config.js';
import APIGet from '../../services/apiCall/get';
import APIPost from '../../services/apiCall/post';

import BannerStyle from './bannerStyle';
import BannerContent from './bannerContent';
import Slots from '../scheduledAds/slot';
import AdType from '../scheduledAds/ad-type';
import BannerStyleLocal from './bannerStyleLocal';

/*Assets*/
// import ViewAdContentModal from '../../components/modals/viewAdContentModal';

class CreateAds extends Component {
  constructor(props){
    super(props);
    this.state = {
      adLocations: [],
      step: 1,
      activeAccordion: 0
    }
  }

  selectChange = async (category) => {
    await this.setState({category: category});
  }

  getAdLocations(){
    this.setState({apiLoading: true});
    var url = devconfig.vendor+ 'ads/pages';
    // var data = JSON.stringify({type: 2});
    APIGet(url).then(function(response){
      if(response.status == "ok"){
        console.log(response.data);
        this.setState({ adLocations: response.data, apiLoading: false });
      }
    }.bind(this))
  }

  componentDidMount(){
    this.getAdLocations()
    let type = 1;
    if(localStorage.getItem("vendor_data")){
      type = JSON.parse(localStorage.getItem("vendor_data")).seller_type
    } 
    this.setState({seller_type: type});
  }

  createAdClick(location){
    var data = { adLocation: location };
    this.nextStep(data)
  }

  async nextStep(data){
    await this.setState({step: this.state.step + 1, data: data});
  }

  goBack(){
    this.setState({step: this.state.step - 1})
  }

  render() {

     const filterBy = [
      { value: 1, label: 'Active' },
      { value: 2, label: 'Ongoing' },
      { value: 3, label: 'Completed' },
    ]
    console.log(this.state.data)
    return (
      <React.Fragment>
      {
        this.state.step === 1? null
        :
          <span className="m-5 pt-3 btn-link hand e-cread-ad-back" onClick={this.goBack.bind(this)}><span>&larr;</span> Back to Previous Step</span>

      }
      {
        this.state.apiLoading?
          <APILoader />
        : this.state.step===1?
          <div className="e-main-content e-vendor-table e-createAds">
            <h2 className="e-page-head">
              Create Ad's
            </h2>
            <div className="row">
              <div className="col-lg-12">
                <h6>Select Ad's type or location</h6>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-10">
              {
                this.state.adLocations.map((page, index)=>{
                  return(
                    <div className="accordion pt-3" id="accordionExample">
                      <div className="card e-vendor-category-list e-createAds-wrap">
                        <div className="card-header" id="headingOne">
                          <div className="row">
                            <div className="col-lg-12">
                              <button className={this.state.activeAccordion === index ? "btn btn-link" : "btn btn-link collapsed" } onClick={(tempVal) => this.setState({activeAccordion: index})} type="button" data-toggle="collapse" data-target={"#collapseOne"+index} aria-expanded={this.state.activeAccordion === index ? "true" : "false" } aria-controls="collapseOne">
                                <div className="row">
                                  <div className="col-lg-12 pl-0">
                                    <h6 className="text-left">{page.name}</h6>
                                  </div>
                                </div>
                              </button>
                            </div>
                          </div>

                        </div>
                        <div id={"collapseOne"+index} className={this.state.activeAccordion === index ? "collapse show" : "collapse"} aria-labelledby="headingOne" data-parent="#accordionExample">
                          <div className="card-body e-createAds-header">
                            <div className="e-border-createAd">

                              {
                                page.ads_location.map((location, index3)=>{
                                  var contentTypes = "";
                                  if(location.ads_content_ids.length==3){
                                    contentTypes = "Images, Videos & Gifs"
                                  }
                                  else{
                                    if(location.ads_content_ids.includes(1)){
                                      contentTypes = "Images"
                                    }
                                    if(location.ads_content_ids.includes(2)){
                                      if(contentTypes.length){
                                        contentTypes = contentTypes + " & Videos"
                                      }else{
                                        contentTypes = "Videos"
                                      }
                                    }
                                    if(location.ads_content_ids.includes(3)){
                                      if(contentTypes.length){
                                        contentTypes = contentTypes + "& Gifs"
                                      }else{
                                        contentTypes = "Gifs"
                                      }
                                    }
                                  }

                                  var validityType = location.validity_type===1? "Days" : location.validity_type===2? "Months" : location.validity_type===3? "Years" : location.validity_type===4?  "Hours": "Days";
                                  if(location.time_left<=0){ return null }

                                  return(
                                    <div className="row my-3">
                                      <div className="col-lg-4">
                                        <p className="e-createAds-content">{location.ads_location}</p>
                                      </div>
                                      <div className="col-lg-3">
                                        <p className="e-createAds-content">Plan: {location.validity_type==4?"Advertisement": "Membership"}</p>
                                      </div>
                                      <div className="col-lg-2">
                                        <p className="e-createAds-content">{contentTypes}</p>
                                      </div>
                                      <div className="col-lg-1 pr-0">
                                        <p className="e-createAds-content">{location.time_left} {validityType}</p>
                                      </div>
                                      {/*<div className="col-lg-2">
                                        <span className="e-view-sample" data-toggle="modal" data-target="#sample" tabindex="-1" role="dialog">View Sample</span>
                                      </div>*/}
                                      <div className="col-lg-2 text-right">
                                        <span className="e-createAds-link" onClick={this.createAdClick.bind(this, location)}>Create Ad</span>
                                      </div>
                                    </div>
                                  );
                                })

                              }




                              {/*<div className="row my-3">
                                <div className="col-lg-4">
                                {
                                  page.ads_location.map((location, index2)=>{
                                    // if(!location.time_left){ return null }
                                    return(
                                      <p className="e-createAds-content">{location.ads_location}</p>
                                    )
                                  })
                                }
                                </div>
                                <div className="col-lg-3">
                                {
                                  page.ads_location.map((location, index2)=>{
                                    // if(!location.time_left){ return null }
                                    var contentTypes = "";
                                    if(location.ads_content_ids.length==3){
                                      contentTypes = "Images, Videos & Gifs"
                                    }
                                    else{
                                      if(location.ads_content_ids.includes(1)){
                                        contentTypes = "Images"
                                      }
                                      if(location.ads_content_ids.includes(2)){
                                        if(contentTypes.length){
                                          contentTypes = contentTypes + " & Videos"
                                        }else{
                                          contentTypes = "Videos"
                                        }
                                      }
                                      if(location.ads_content_ids.includes(3)){
                                        if(contentTypes.length){
                                          contentTypes = contentTypes + "& Gifs"
                                        }else{
                                          contentTypes = "Gifs"
                                        }
                                      }
                                    }
                                    return(
                                      <p className="e-createAds-content">{contentTypes}</p>
                                    )
                                  })
                                }
                                </div>
                                <div className="col-lg-1 pr-0">
                                {
                                  page.ads_location.map((location, index3)=>{
                                    // if(!location.time_left){ return null }
                                    var validityType = location.validity_type===1? "Days" : location.validity_type===2? "Months" : location.validity_type===3? "Years" : location.validity_type===4?  "Hours": "Days";
                                    
                                    return(
                                      <p className="e-createAds-content">{location.time_left} {validityType}</p>
                                    )
                                  })
                                }
                                </div>
                                <div className="col-lg-2">
                                {
                                  page.ads_location.map((location, index3)=>{
                                    return(
                                      <p className="e-createAds-content">
                                        <span className="e-view-sample" data-toggle="modal" data-target="#sample" tabindex="-1" role="dialog">View Sample</span>
                                      </p>
                                    )
                                  })
                                }
                                </div>
                                <div className="col-lg-2">
                                {
                                  page.ads_location.map((location, index3)=>{
                                    return(
                                      <p className="e-createAds-content">
                                        <span className="e-createAds-link" onClick={this.createAdClick.bind(this, location)}>Create Ad</span>
                                      </p>
                                    )
                                  })
                                }
                                      
                                </div>
                              </div>*/}


                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })
              }
              </div>
            </div>







            {/*Modals*/}
           <ViewSampleModal/>
          </div>
        : this.state.step===2?
            <>
            {
              this.state.seller_type && this.state.seller_type ===1?
              <BannerStyle data={this.state.data} nextStep={this.nextStep.bind(this)}/>
              :
              <BannerStyleLocal data={this.state.data} nextStep={this.nextStep.bind(this)}/>
            }
            </>
        : this.state.step===3?
            <BannerContent data={this.state.data} nextStep={this.nextStep.bind(this)}/>
        : this.state.step===4?
            <Slots data={this.state.data} nextStep={this.nextStep.bind(this)}/>
        : this.state.step===5?
            <AdType data={this.state.data} nextStep={this.nextStep.bind(this)} local={this.state.seller_type && this.state.seller_type ===1? false: true}/>
        :
          null
      }
      </React.Fragment>

    );
  }
}

export default CreateAds;
